;(function() {
  const {
    VUE_APP_KETCH_PROPERTY_CODE,
    VUE_APP_KETCH_REGION_DOMAIN_URL,
    VUE_APP_KETCH_ORG_CODE,
    VUE_APP_KETCH_BOOT_FILE_PATH,
  } = process.env
  !function() {
    window.semaphore = window.semaphore || [], window.ketch = function() {
      window.semaphore.push(arguments)
    }
    const bootFilePath = VUE_APP_KETCH_BOOT_FILE_PATH.startsWith('/')
      ? VUE_APP_KETCH_BOOT_FILE_PATH.slice(1)
      : VUE_APP_KETCH_BOOT_FILE_PATH;

    const e = document.createElement('script')
    e.type = 'text/javascript', e.src = `${VUE_APP_KETCH_REGION_DOMAIN_URL}/${VUE_APP_KETCH_ORG_CODE}/${VUE_APP_KETCH_PROPERTY_CODE}/${bootFilePath}`,
      e.defer = e.async = !0, document.getElementsByTagName('head')[0].appendChild(e)
  }()
  !(function () {
    document.addEventListener('DOMContentLoaded', function () {
      function preventDefaultByClassName(className, preventDefaultAction) {
        const elements = document.getElementsByClassName(className)
        for (const element of elements) {
          element.addEventListener('click', (event) => {
            event.preventDefault()
            preventDefaultAction()
          })
        }
      }
      preventDefaultByClassName('data-request-over-ride', () => {
        window.semaphore.push(['showPreferences', { tab: 'rightsTab' }])
      })
    })
  })()
})();
